import type { ThemeV3 } from '../types/themeTypes';

/** A deep ember charcoal with a soft amber accent. */
export const emberTheme = {
  id: 'Ember',
  name: 'Ember',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': 'oklch(0.16 0.01 55deg)',
    'surface-1': 'oklch(0.2 0.01 55deg)',
    'surface-2': 'oklch(0.24 0.012 55deg)',
    'surface-3': 'oklch(0.27 0.012 55deg)',
    'surface-4': 'oklch(0.31 0.014 55deg)',
    'content-0': 'oklch(0.95 0.008 55deg)',
    'content-1': 'oklch(0.83 0.008 55deg)',
    'content-2': 'oklch(0.73 0.008 55deg)',
    'content-3': 'oklch(0.63 0.008 55deg)',
    'content-4': 'oklch(0.55 0.008 55deg)',
    edge: 'oklch(0.31 0.014 55deg)',
    'edge-muted': 'oklch(0.27 0.012 55deg)',
    accent: 'oklch(0.75 0.15 55deg)',
    red: 'oklch(0.75 0.15 25.331deg)',
    orange: 'oklch(0.75 0.15 47.604deg)',
    amber: 'oklch(0.75 0.15 70.08deg)',
    yellow: 'oklch(0.75 0.15 86.047deg)',
    lime: 'oklch(0.75 0.15 130.85deg)',
    green: 'oklch(0.75 0.15 149.579deg)',
    teal: 'oklch(0.75 0.15 182.503deg)',
    cyan: 'oklch(0.75 0.15 215.221deg)',
    blue: 'oklch(0.75 0.15 259.815deg)',
    violet: 'oklch(0.75 0.15 292.717deg)',
    purple: 'oklch(0.75 0.15 303.9deg)',
    pink: 'oklch(0.75 0.15 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-0) 80%, var(--color-content-0))',
  },
} satisfies ThemeV3;
